import styled from 'styled-components';

export const ConfirmModalText = styled.div`
  color: ${props => props.theme.interface5};
  font-weight: normal;
`;
